import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Shield, FileText, Heart } from 'lucide-react';

export default function OurCompliance() {
  return (
    <div className="min-h-screen compliance-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-10 lg:py-10">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center space-y-6">
            <Badge className="bg-primary/10 text-primary hover:bg-primary/20 border-primary/20">
              Compliance
            </Badge>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground font-['Space_Grotesk'] leading-tight">
              Compliance
            </h1>
          </div>
        </div>
      </section>

      {/* Quality & Compliance */}
      <section className="py-10">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <Card className="card-glass border-blue-200/50 shadow-xl pulse-bg card-border-hover blue">
              <CardHeader>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500/10 to-purple-500/10 flex items-center justify-center icon-container compliance-icon">
                    <Shield className="h-6 w-6 text-blue-600" />
                  </div>
                  <CardTitle className="text-2xl bg-gradient-to-r from-gray-800 to-blue-600 bg-clip-text text-transparent">
                    Quality & Compliance
                  </CardTitle>
                </div>
              </CardHeader>
              <CardContent className="space-y-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  Quality is embedded at every stage of our operations.
                </p>
                
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Standards & Systems</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      WHO-GMP
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      ISO-certified processes
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      ICH guidelines
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      Data integrity & audit readiness
                    </li>
                  </ul>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Regulatory Affairs */}
      <section className="py-10 bg-muted/30">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <Card className="card-hover card-gradient-secondary border-purple-200/50 card-border-hover purple">
              <CardHeader>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-purple-500/10 to-pink-500/10 flex items-center justify-center icon-container compliance-icon">
                    <FileText className="h-6 w-6 text-purple-600" />
                  </div>
                  <CardTitle className="text-2xl bg-gradient-to-r from-gray-800 to-purple-600 bg-clip-text text-transparent">
                    Regulatory Affairs
                  </CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Our regulatory team ensures timely submissions and lifecycle management in compliance with national and international regulatory authorities.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Pharmacovigilance */}
      <section className="py-10">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <Card className="card-hover card-gradient-accent border-green-200/50 card-border-hover green">
              <CardHeader>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-green-500/10 to-emerald-500/10 flex items-center justify-center icon-container compliance-icon">
                    <Heart className="h-6 w-6 text-green-600" />
                  </div>
                  <CardTitle className="text-2xl bg-gradient-to-r from-gray-800 to-green-600 bg-clip-text text-transparent">
                    Pharmacovigilance
                  </CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Apken Pharma is committed to patient safety through continuous monitoring, reporting, and evaluation of adverse events.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
}
